import React from 'react';
import { useParallax } from 'react-scroll-parallax';
import './AboutPages.css';
// Import the background image
import healthcareBgImage from '../assets/images/healthcare-bg.jpg';
// Import the RunningScrollCard component
import RunningScrollCard from '../components/RunningScrollCard';

const AboutTeam = () => {
  const titleParallax = useParallax({
    translateY: [20, -20],
    opacity: [0.8, 1],
    scale: [0.95, 1],
    easing: 'easeInQuad',
    startScroll: 0,
    endScroll: 300
  });

  const contentParallax = useParallax({
    translateY: [50, 0],
    opacity: [0.6, 1],
    scale: [0.98, 1],
    easing: 'easeOutQuad',
    startScroll: 0,
    endScroll: 500
  });

  const teamParallax = useParallax({
    translateY: [80, 0],
    opacity: [0.4, 1],
    easing: 'easeOutQuad',
    startScroll: 200,
    endScroll: 600
  });

  // Team members data
  const executiveTeam = [
    {
      title: 'Co-Founder',
      qualifications: [
        '10+ years of exp in Data & Analytics',
        'B.Tech - NIT Warangal',
        'MBA - IIM Calcutta'
      ]
    },
    {
      title: 'Co-Founder',
      qualifications: [
        '7+ years of exp in AI & ML ',
      
      ]
    },
    {
      title: 'Chief Sales Officer',
      qualifications: [
        '15+ Years of exp in Software Applications, DBM and ERP',
        'Founder of multitude of tech companies'
      ]
    }
  ];

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero team-hero">
        <div className="about-hero-bg" style={{ backgroundImage: `url(${healthcareBgImage})` }}>
          <div className="about-hero-overlay"></div>
        </div>
        <div ref={titleParallax.ref} className="about-hero-content">
          <h1 className="about-hero-title">Our Team</h1>
          <p className="about-hero-subtitle">Meet the experts behind Hyperion AI's innovative solutions</p>
        </div>
      </section>

      {/* Team Overview */}
      <section className="about-section">
        <div className="about-container">
          <div ref={contentParallax.ref} className="about-content">
            <h2 className="about-section-title">Who We Are</h2>
            <div className="about-text-content">
              <p>
                At Hyperion AI, our greatest asset is our team of passionate AI experts, engineers, researchers, and business professionals. We bring together diverse perspectives and expertise to create AI solutions that are innovative, ethical, and impactful.
              </p>
              <p>
                Our team includes Ph.D. researchers from top universities, engineers with experience at leading tech companies, and business strategists who understand how to translate AI capabilities into real business value. We're united by a shared mission to democratize AI and help businesses of all sizes harness its transformative potential.
              </p>
              <p>
                We believe in collaboration, continuous learning, and maintaining a culture where bold ideas can flourish. This approach has allowed us to build a team that consistently delivers cutting-edge AI solutions while maintaining the highest standards of quality and ethics.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Leadership Team */}
      <section className="team-section dark-team-section">
        <div className="about-container">
          <h2 className="about-section-title">LEADERSHIP TEAM</h2>
          <div ref={teamParallax.ref} className="team-grid">
            {executiveTeam.map((member, index) => (
              <RunningScrollCard key={index}>
                <div className="team-card">
                  <div className="team-image-container">
                    <div className="team-image-placeholder">
                      {/* Placeholder for executive team images */}
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                      </svg>
                    </div>
                  </div>
                  <div className="team-info">
                    <h3 className="team-title">{member.title}</h3>
                    <ul className="team-qualifications">
                      {member.qualifications.map((qualification, qIndex) => (
                        <li key={qIndex}>{qualification}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </RunningScrollCard>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutTeam;
